@if (showModal) {
  <div [ngClass]="{'top-border-round' : !isMobile}"
    class="cookie-modal-wrapper">
    @if (!disappear) {
      <div
        [@appearSlowlyAnimation]
        class="bottom-modal">
        <div [ngClass]="isMobile ? 'mobile-css' : 'desktop-css'"
          class="bottom-modal-body white-bg">
          <div class="modal-header-icon-container">
            <div class="header-img clear-button mt-3">
              <app-page-content-header
                (closeButtonClick)="onClose()"
                [showCloseButton]="true">
              </app-page-content-header>
            </div>
          </div>
          <div [innerHtml]="content" appLinkHandler id=modal-description></div>
          @if (showButtons) {
            <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}"
              class="bottom-modal-btn-container my-4">
              <button (click)="onAccept()" class="btn btn-primary mt-2"
                style="min-width: 12rem;">{{ 'shared.accept' |translate }}
              </button>
              <button (click)="onNotAccept()"
                class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2">{{ 'shared.doNotAccept' | translate | uppercase }}
              </button>
            </div>
          }
          @if (showBackButton) {
            <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}"
              class="bottom-modal-btn-container my-4">
              <button (click)="onClose()"
                class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2">{{ 'shared.back' | translate | uppercase }}
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
